import { render, staticRenderFns } from "./QuestionViewImage.vue?vue&type=template&id=52f3ee84"
import script from "./QuestionViewImage.vue?vue&type=script&lang=js"
export * from "./QuestionViewImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports